import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, App } from 'ionic-angular';
import { MaterialApoyoDetallePage } from '@pages';
import { MaterialesApoyoProvider } from '@providers/materiales-apoyo/materiales-apoyo';
import { AuthProvider } from '@providers/auth/auth';
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-materiales-apoyo',
  templateUrl: 'materiales-apoyo.html',
})
export class MaterialesApoyoPage {

  jugador: any;
  equipo: any;
  materialesApoyo: Array<any>;
  rows: Array<any>;
  filtros: Array<any>;
  campaign: any;
  termFilter: string;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public materialesApoyoProvider: MaterialesApoyoProvider,
    public authProvider: AuthProvider,
    public app: App,
    public campaignsProvider: CampaignsProvider,
    private translateService: TranslateService,
  ) {
    this.materialesApoyo = [];
    this.rows = [];
    this.filtros = [];
  }
  
  async ionViewWillEnter() {
    this.initFiltros();

    this.campaign = await this.campaignsProvider.get();

    this.jugador = await this.authProvider.getSession();
    this.equipo = await this.authProvider.getEquipo();
    this.getMateriales();
  }

  initFiltros() {
    setTimeout( _ => {
      this.filtros = [
        {
          tipo: 'VIDEO',
          etiqueta: this.translateService.instant('materialesApoyo.tags.video'),
          esSeleccionado: false
        },
        {
          tipo: 'IMAGEN',
          etiqueta: this.translateService.instant('materialesApoyo.tags.image'),
          esSeleccionado: false
        },
        {
          tipo: 'ARCHIVO',
          etiqueta: this.translateService.instant('materialesApoyo.tags.file'),
          esSeleccionado: false
        },
        {
          tipo: 'AUDIO',
          etiqueta: this.translateService.instant('materialesApoyo.tags.audio'),
          esSeleccionado: false
        },
        {
          tipo: 'TEXTO',
          etiqueta: this.translateService.instant('materialesApoyo.tags.text'),
          esSeleccionado: false
        },
      ];
    }, 300);
  }

  async getMateriales(refresher = null) {
    const response = await this.materialesApoyoProvider.getAll(this.equipo.area._id);

    this.materialesApoyo = response;
    this.rows = response;

    if(refresher) {
      refresher.complete();
    }

    this.filtrarMaterialesApoyo();
  }

  handleFilter(filtro) {
    filtro.esSeleccionado = !filtro.esSeleccionado;
    // this.filtros = this.filtros.sort( (a, b) => b.esSeleccionado - a.esSeleccionado);
    this.filtrarMaterialesApoyo();
  }

  showAllFilters() {
    this.filtros.forEach( f => f.esSeleccionado = false );
    this.filtrarMaterialesApoyo();
  }

  isAllFilters() {
    return this.filtros.filter( f => f.esSeleccionado ).length == 0;
  }

  filtrarMaterialesApoyo(event?: any) {
    let filtros = this.filtros.filter( f => f.esSeleccionado );

    this.materialesApoyo = this.rows.filter( r => !filtros.length || filtros.find( f => f.tipo == r.tipo )  );

    this.filterAsset();
  }

  goToDetail(material) {
    // this.navCtrl.push(MaterialApoyoDetallePage, {
    //   material: material
    // });

    // this.app.getActiveNav().push(MaterialApoyoDetallePage, {
    //   material: material
    // });

    this.app.getRootNav().push(MaterialApoyoDetallePage, {
      material: material
    });
  }


  filterAsset() {
    const query = this.termFilter;
    if (query) {  
      this.materialesApoyo = this.materialesApoyo.filter( row =>
        (
          row.titulo.match(new RegExp(`${query}`, 'i')) ||
          row.descripcion.match(new RegExp(`${query}`, 'i')) ||
          row.tags.join(',').match(new RegExp(`${query}`, 'i'))
        )
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/materiales-apoyo/materiales-apoyo.ts